import { defineStore } from 'pinia'
import { firedataStore } from './firedata'
// import { store } from './index'
import router from '../router';
import {
    getAuth,
    onAuthStateChanged,
} from "firebase/auth";
import { useToast } from "vue-toastification";
import {
    getDatabase, ref, onValue,
    // update 
} from "firebase/database";
const toast = useToast()
// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const authStore = defineStore('authStore', {
    state: () => ({
        user: null,
        userId: null,
        idToken: null,
        userEmail: null,
        loadingMessage: null
    }),
    actions: {
        authenticate() {
            return new Promise((resolve, reject) => {
                const useFiredataStore = firedataStore()
                useFiredataStore.getData();
                this.loadingMessage = "Checking login..";
                const auth = getAuth();
                onAuthStateChanged(auth, (user) => {
                    console.log("ON AUTH STATE CHANGE RUNNING");
                    if (user) {
                        this.user = user;

                        useFiredataStore.getAllSessions();

                        toast("Signed in as " + user.email)

                        if (this.user) {
                            if (router.currentRoute._value.fullPath === "/") {
                                router.push("/dashboard");
                            } else if (router.currentRoute._value.fullPath === "/login") {
                                router.push("/dashboard");
                            } else if (router.currentRoute._value.fullPath === "/register") {
                                router.push("/dashboard");
                            }
                        }
                        // useFiredataStore.getData();

                        this.loadingMessage = null;
                        localStorage.setItem('user', JSON.stringify(user));
                        resolve();
                    } else {
                        this.user = null;
                        localStorage.clear();
                        if (router.currentRoute._value.fullPath === "/login" && router.currentRoute._value.fullPath === "/register") {
                            toast("Signed outzzz. " + router.currentRoute._value.fullPath)
                        }
                        this.loadingMessage = null;
                        reject();
                    }
                });
                if (/Android/i.test(navigator.userAgent)) {
                    setTimeout(() => {
                        const db = getDatabase();
                        const appVersion = ref(db, "/appinfo/version");
                        onValue(appVersion, (snapshot) => {
                            if (snapshot.val() > this.appVersion) {
                                toast.success("Update aviable. Click here to download Play Store update.", {
                                    timeout: false,
                                    onClick: () => window.open('https://play.google.com/store/apps/details?id=com.birdiefy.app'),
                                    closeButton: "button",
                                })
                            }

                        });

                    }, 500);
                }
            })
        },

    }
})
